import { EVENT_CODE, FORM_TYPE } from '@constants'
import { ActionRow, Row } from '@types'

type FindActionProps = {
  eventCode?: EVENT_CODE
  actions?: ActionRow[]
  type?: FORM_TYPE
}

export type GetVerifyFormTitleProps = {
  row?: Row
} & FindActionProps

export const getVerifyFormTitle = ({ actions, eventCode }: GetVerifyFormTitleProps) => {
  if (eventCode) {
    const action = actions ? actions.find(action => action.eventCode === eventCode) : null

    if (action) {
      return action.objectFormTitle ?? null
    }

    return null
  }

  return null
}
